import { object, string } from 'valibot';

export const schemeFooterContent = object({
	text: string(),
});
